var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUploadFile01 = function SvgUploadFile01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 37.45,
    y1: 159.69,
    x2: 134.58,
    y2: 50.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 14.12,
    y1: 139,
    x2: 111.25,
    y2: 29.45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 82.6,
    y1: 199.71,
    x2: 179.73,
    y2: 90.16,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M145.33,86.58v-37.85c0-1.08-.5-2.08-1.21-2.88L101.69,1.29c-.79-.83-1.92-1.29-3.04-1.29H31.37C18.95,0,9.02,10.13,9.02,22.55v127.22c0,12.42,9.92,22.38,22.34,22.38h53.11c10.04,16.67,28.3,27.84,49.1,27.84,31.6,0,57.4-25.68,57.4-57.32.04-27.64-19.8-50.73-45.64-56.11ZM102.81,14.63l28.47,29.97h-18.47c-5.5,0-10-4.54-10-10.04V14.63ZM80.55,120.93h-37.85c-2.29,0-4.17,1.88-4.17,4.17s1.88,4.17,4.17,4.17h35.14c-1.04,4.17-1.58,8.8-1.58,13.42,0,7.5,1.46,14.92,4.08,21.18H31.37v-.04c-7.79,0-14-6.25-14-14.05V22.55c0-7.84,6.21-14.21,14-14.21h63.11v26.22c0,10.13,8.21,18.38,18.34,18.38h24.18v32.55c-1.25-.04-2.25-.17-3.33-.17-14.55,0-27.93,5.59-38.02,14.34h-52.94c-2.29,0-4.17,1.88-4.17,4.17s1.88,4.17,4.17,4.17h45.19c-2.96,4.17-5.42,8.34-7.34,12.92ZM133.62,191.71c-27.01,0-48.98-21.97-48.98-48.98s21.93-48.98,48.98-48.98,48.98,21.97,48.98,48.98-21.97,48.98-48.98,48.98Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.71,87.12h42.23c2.29,0,4.17-1.88,4.17-4.17s-1.88-4.17-4.17-4.17h-42.23c-2.29,0-4.17,1.88-4.17,4.17s1.88,4.17,4.17,4.17Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136.58,111.96c-.79-.83-1.88-1.33-3.04-1.33s-2.25.5-3.04,1.33l-24.43,26.22c-1.58,1.67-1.46,4.34.21,5.88,1.67,1.58,4.38,1.46,5.96-.21l17.26-18.47v45.52c0,2.29,1.88,4.17,4.17,4.17s4.17-1.88,4.17-4.17v-45.52l17.13,18.47c.83.87,1.92,1.33,3.04,1.33,1,0,2-.38,2.83-1.13,1.67-1.58,1.79-4.21.21-5.88l-24.47-26.22Z"
  })));
};
export default SvgUploadFile01;